var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwedenSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H9v5h10V5a1 1 0 0 0-1-1zM1 15c0 .553.248 1 .8 1H7v-5H1v4zm8 1h9a1 1 0 0 0 1-1v-4H9v5zM1 5v4h6V4H1.8c-.552 0-.8.447-.8 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwedenSvg);
export default __webpack_public_path__ + "static/media/sweden-svg.7fa7e2e61cc3a8f6b20db7a6a9ae762c.svg";
export { ForwardRef as ReactComponent };